var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconImgAllSpeakerAbled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8906 8.07293L8.50385 10.9974C8.17531 11.2165 7.7893 11.3333 7.39445 11.3333H6C4.89543 11.3333 4 12.2288 4 13.3333V20C4 21.1046 4.89543 22 6 22H7.52786C7.83835 22 8.14458 22.0723 8.42229 22.2111L13.1056 24.5528C14.4354 25.2177 16 24.2507 16 22.7639V9.73703C16 8.13964 14.2197 7.18686 12.8906 8.07293Z",
    fill: "#6360F6",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4644 11.9166C21.0228 13.1634 21.3333 14.5454 21.3333 15.9999C21.3333 17.4544 21.0228 18.8364 20.4644 20.0832",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1573 8C25.739 10.2677 26.6667 13.0255 26.6667 16C26.6667 18.9745 25.739 21.7323 24.1573 24",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconImgAllSpeakerAbled);
export default __webpack_public_path__ + "static/media/iconImgAllSpeakerAbled.f81fec2d32d3950ed40ad1f8f6f472b3.svg";
export { ForwardRef as ReactComponent };